import { render, staticRenderFns } from "./LexicalReloadPlugin.vue?vue&type=template&id=23f39504&"
import script from "./LexicalReloadPlugin.vue?vue&type=script&lang=js&"
export * from "./LexicalReloadPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports